const hasCuratedElevatedProductTiles = (treatments) =>
  treatments?.configuration?.some(({ treatmentDefinitions }) =>
    treatmentDefinitions?.some(({ pinnedProducts }) =>
      pinnedProducts?.some(({ pinType }) => pinType === "elevated"),
    ),
  ) || false;

export default hasCuratedElevatedProductTiles;
